import { FC, ReactNode } from "react";
import { QESButton } from "@app/shared/qes-standards/Button";

interface NetworkProfileRegulatorCommunicationData {
  phoneNumber: string | null;
  underReviewBy: string | null;
}

//TODO: Replace with real data from service
const mockData: NetworkProfileRegulatorCommunicationData = {
  phoneNumber: "(828) 765-8124",
  underReviewBy: "MDHHS",
};

interface RegulatorRowProps {
  label: string;
  testId: string;
  value: ReactNode;
}

const RegulatorRow: FC<RegulatorRowProps> = ({ label, testId, value }) => (
  <div className="compliance-connect-network-profile__overview-row np-gray-border-bottom" data-testid={testId}>
    <span className="compliance-connect-network-profile__overview-label" data-testid={`${testId}-label`}>{label}</span>
    <span className="compliance-connect-network-profile__overview-value" data-testid={`${testId}-value`}>{value}</span>
  </div>
);

interface NetworkProfileRegulatorCommunicationProps {
  data?: NetworkProfileRegulatorCommunicationData;
  onViewComments?: () => void;
  unreadCommentCount?: number | null;
}

export const NetworkProfileRegulatorCommunication: FC<NetworkProfileRegulatorCommunicationProps> = ({
  data = mockData,
  onViewComments,
  unreadCommentCount = null,
}) => (
  <div className="compliance-connect-network-profile__card" data-testid="network-profile-regulator-communication">
    <h4 className="compliance-connect-network-profile__card-title np-gray-border-bottom" data-testid="network-profile-regulator-communication-title">Regulator Communication</h4>
    <div className="compliance-connect-network-profile__overview" data-testid="network-profile-regulator-communication-rows">
      <RegulatorRow label="Under Review By" testId="network-profile-regulator-communication-row-under-review-by" value={data.underReviewBy ?? "—"} />
      <RegulatorRow
        label="Regulator Comments"
        testId="network-profile-regulator-communication-row-regulator-comments"
        value={
          unreadCommentCount === null ? "—" :
          unreadCommentCount > 0 ? (
            <QESButton qesTestId="network-profile-regulator-communication-row-regulator-comments-link" qesType="link" onClick={onViewComments}>
              <strong>{unreadCommentCount} Unread Comment{unreadCommentCount === 1 ? "" : "s"}</strong>
            </QESButton>
          ) : "No Unread Comments"
        }
      />
      <RegulatorRow label="Phone Number" testId="network-profile-regulator-communication-row-phone-number" value={data.phoneNumber ?? "—"} />
    </div>
  </div>
);
